import * as React from 'react';
import * as Clients from '../../client/ApiClient';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Col, Container, Row, Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import DataListInput from '../basic/DataListInput';
import { DataCell, DataRow, DataTable, DataTableButton } from '../basic/DataTable';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as Roles from 'constants/Roles';
import EditUserPage  from '../../components/user/EditUser'

interface IManageUsersPageProps extends RouteComponentProps<{ userId?: string }> {
    currentUser: Clients.IUserLoginDetailsModel | undefined;
    conversionId: string;
    clientId: string;
    isCustomerAdministrator: boolean | undefined;
    isAdministrator: boolean | undefined;
};

interface IManageUsersPageState {
    userList: Clients.UserModel[] | null;
    selected: string;
    conversionTypes: Clients.ConversionTypeModel[] | null;
    modal: boolean;
}

class ManageUsersPage extends React.Component<IManageUsersPageProps, IManageUsersPageState>{
    private readonly users: Clients.UserClient = new Clients.UserClient();
    private readonly userToConversionClient: Clients.UserToConversionClient = new Clients.UserToConversionClient();

    constructor(props: IManageUsersPageProps) {
        super(props)
        this.state = {
            selected: '',
            userList: null,
            conversionTypes: null,
            modal: false,
        }
    }

    componentDidMount() {
        this.showUsers();
    }

    showUsers = () => {
        this.users.listManageUsers(this.props.conversionId, this.props.clientId)
            .then(response => {
                if (response) this.setState({ userList: response })
            })
            .catch(err => console.log(err))
    }

    projectStatus = (userid: string, type: string) => {
        const request = new Clients.UpdateUserToConversionRequestModel();

        request.insert = type === 'insert' ? [
            new Clients.UserToConversionModel({
                userId: userid,
                conversionId: this.props.conversionId,
            })] : [];

        request.remove = type === 'remove' ? [
             new Clients.UserToConversionModel({
            userId: userid,
            conversionId: this.props.conversionId,
        })] : [];

        this.userToConversionClient.patch(userid, request).
            then(() => {
                this.showUsers()
            })
            .catch(err => console.log(err))
    }

    activate = (user: Clients.UserModel) => {
        if (this.state.modal) { this.setState({ modal: false }) }
        user.isActive = !user.isActive;

        (user.role as any).createdDate = undefined;
        (user.role as any).lastEditedDate = undefined;
        this.users.put(user.id as string, user)
            .then(() => {
                this.showUsers();
            })
            .catch(error => { console.log(error) })
    }

    public render() {
        return (
            <>
                <Container>
                    <Row>
                        <Col>
                            <h3>
                                Manage Users
                            </h3>
                            <Button
                                className='submit-button-orange float-left'
                                onClick={(e) => { this.setState({ modal: true }); e.currentTarget.blur(); }}
                            >Add New User</Button>
                            <br />
                            <DataTable hover >
                                <thead>
                                    <tr>
                                        <th className="number-column">#</th>
                                        <th>
                                            Last Name
                                        </th>
                                        <th>
                                            First Name
                                        </th>
                                        <th>
                                            Email Address
                                        </th>
                                        <th>
                                            Roles
                                        </th>
                                        <th>
                                            User Status
                                        </th>
                                        <th>
                                            Project Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="groupEmailTable">
                                    {this.state.userList && this.state.userList!
                                        .map((u, i) => {
                                            return (<DataRow id={u.id!.toString()} key={u!.id}>
                                                <DataCell className="number-column">
                                                    {i + 1}
                                                </DataCell>
                                                <DataCell>
                                                    {u.lastName}
                                                </DataCell>
                                                <DataCell>
                                                    {u.firstName}
                                                </DataCell>
                                                <DataCell>
                                                    {u.emailAddress}
                                                </DataCell>
                                                <DataCell>
                                                    {u.role?.description}
                                                </DataCell>
                                                <DataCell>
                                                    {u.isActive ? <Badge
                                                        color="success"
                                                        /*onClick={() => this.activate(u)}*/
                                                        pill
                                                    >Active
                                                    </Badge> :
                                                        <Badge
                                                            color="danger"
                                                            /*onClick={() => this.activate(u)}*/
                                                            pill
                                                        >
                                                            Inactive
                                                        </Badge>}
                                                </DataCell>
                                                <DataCell>
                                                    {u.projectStatus ?
                                                        <><DataTableButton
                                                            icon='check_circle'
                                                            id={i + "User"}
                                                            title='No Access'
                                                            color={'#2e961a'}
                                                            action={() => this.projectStatus(u.id!, 'remove')} />
                                                            Access</> :
                                                        <><DataTableButton
                                                            icon='do_not_disturb_on'
                                                            id={i + "User"}
                                                            title='Access'
                                                            color={'#999c98'}
                                                            action={() => this.projectStatus(u.id!, 'insert') } />No Access</>}
                                                </DataCell>
                                            </DataRow>)
                                        })}
                                </tbody>
                            </DataTable>
                        </Col>
                    </Row>
                    <Row>
                    </Row>
                </Container >
                <Modal isOpen={this.state.modal} size="xl">
                    <ModalBody>
                        <EditUserPage isEditing={false} user={new Clients.UserModel()} isCurrentUser={false} passwordPlaceholder={false} clientId={this.props.clientId} conversionId={this.props.conversionId} roleId={Roles.customerUserRoleId} close={() => {this.setState({ modal: false }, () => { this.showUsers();}) }} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ modal: false }, () => this.showUsers())}>Close</Button>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}

export default connect(
    (state: ApplicationState) => {
        return {
            isCustomerAdministrator: state.authentication
                && state.authentication.currentUser
                && state.authentication.currentUser.role === Roles.customerAdministratorRoleId,
            isAdministrator: state.authentication
                && state.authentication.currentUser
                && (state.authentication.currentUser.role === Roles.administrationRoleId
                    || state.authentication.currentUser.role === Roles.developerAdministrationRoleId),
            currentUser: state.authentication && state.authentication.currentUser,
            currentSelect: state.select && state.select.userCompany
        }
    },
)(withRouter(ManageUsersPage));
